import { FC } from 'react';
import { useEffect } from "react";

export type StoreLocatorProps = {
  data?: any;
};


const StoreLocator: FC<StoreLocatorProps> = ({ data }) => {
  useEffect(() => {
    // Check if the script is already added to prevent duplicate loading
    if (!document.querySelector("script[src='https://stockist.co/embed/v1/widget.min.js']")) {
      const script = document.createElement("script");
      script.src = "https://stockist.co/embed/v1/widget.min.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div style={{
      padding: window.innerWidth <= 415 ? "10px" : "80px",
    }}>
      <div className="text-[18px] xs:text-[20px] sm:text-[24px] md:text-[30px] lg:text-[35px] xl:text-[40px] mb-5 text-[#555] whitespace-nowrap">
        Your closest stockists
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: `<stockist-store-locator data-stockist-widget-tag="map_7q5pzpn3">
            Loading store locator from <a href="https://stockist.co">Stockist store locator</a>...
          </stockist-store-locator>`
        }}
      />
      
    </div>
  );
};

export default StoreLocator;

